import { GridRowGroupingState } from '@mui/x-data-grid-premium'
import isNil from 'lodash/isNil'
import { toPascalCase } from '@omnea-app/legacy/utils/string/toPascalCase'

export const ROW_GROUPING_NONE_GROUPING_TEXT_VALUE = 'NONE'

export const ROW_GROUPING_RENDERD_COLUMN_TYPE = 'rowGroupByColumnsGroup'

export type RowGroupingModelCriteria = string | undefined

// NOTE (Dalyan): Until we introduce ability to group by multiple rows,
// we will only get the first model criteria element from the
// row grouping model
export const getRowGroupingModelCriteriaFromGridRowGroupingState = (
  rowGroupingState: GridRowGroupingState | undefined
): RowGroupingModelCriteria => rowGroupingState?.model[0]

export const getRowGroupingColumnTableCellValue = (value?: string): string | null => {
  if (isNil(value)) {
    console.error("Argument 'value' is nullish, and thus invalid")
    return null
  }

  if (value === ROW_GROUPING_NONE_GROUPING_TEXT_VALUE) {
    return ROW_GROUPING_NONE_GROUPING_TEXT_VALUE
  }

  return toPascalCase(value)
}
